import { default as Split } from './Split';

export default class extends Split {
    constructor(m) {
        super(m);
    }

    callback() {
        this.initVideo();
    }

    initVideo() {
        this.cursorProgress = 1;
        this.video = document.querySelector('.js-page-video')

        this.canvas = this.el.querySelector('canvas')
        if(!this.canvas) return;

        this.ctx = this.canvas.getContext('2d')

        this.compute()
        this.updateBind = this.update.bind(this)
        this.update()

        this.checkResizeBind = this.checkResize.bind(this)
        window.addEventListener('resize', this.checkResizeBind)
    }

    compute() {
        this.viewportWidth = window.innerWidth;
        this.viewportHeight = window.innerHeight;

        this.BCR = this.canvas.getBoundingClientRect()
        if(Math.round(this.ctx.canvas.width) == Math.round(this.BCR.width) && Math.round(this.ctx.canvas.height) == Math.round(this.BCR.height)) return;
        this.ctx.canvas.width = this.BCR.width
        this.ctx.canvas.height = this.BCR.height
    }

    checkResize() {
        if(!this.resizeTick) {
            this.resizeTick = true
            requestAnimationFrame(() => {
                this.compute()
                this.resizeTick = false
            })
        }
    }

    update() {
        this.ctx.clearRect(0,0,this.ctx.canvas.width,this.ctx.canvas.height)

        this.ctxRatio = this.ctx.canvas.width / this.ctx.canvas.height
        this.videoRatio = this.video.videoWidth/this.video.videoHeight

        if(this.ctxRatio > this.videoRatio) { // context wider than video
            this.ctx.drawImage(this.video,
                0,
                -((this.ctx.canvas.width*(1/this.videoRatio)) - this.ctx.canvas.height)/2,
                this.ctx.canvas.width,
                this.ctx.canvas.width*(1/this.videoRatio)
            );
        } else {
            this.ctx.drawImage(this.video,
                -((this.ctx.canvas.height*this.videoRatio) - this.ctx.canvas.width)/2,
                0,
                this.ctx.canvas.height*this.videoRatio,
                this.ctx.canvas.height);
        }

        this.raf = requestAnimationFrame(this.updateBind)
    }

    destroy() {
        window.removeEventListener('resize', this.checkResizeBind)
        cancelAnimationFrame(this.raf)
    }
}
